// @flow strict

import * as React from 'react';

type PropTypes = {|
  embedSrc: string,
  containerClassName: string,
|};

export default (props: PropTypes) => {
  const { embedSrc = '', containerClassName = '' } = props;

  React.useEffect(() => {
    const script = document.createElement('script');
    // script.setAttribute('async', '');
    script.src = embedSrc;

    if (document.body) {
      document.body.appendChild(script);
    }

    return () => {
      script.remove();
    };
  }, [embedSrc]);

  return containerClassName ? <div id="vevroot" className={containerClassName} /> : null;
};
